const hy = {
  searchPlaceholder: 'Որոնել ըստ բանալի բառերի',
  allQuestionsButtonLabel: 'Բոլոր հարցերը',
  showMoreText: 'Ցույց տալ ավելին',
  showLessText: 'Ցույց տալ պակաս',
  noResultsText: 'Արդյունքներ չեն գտնվել',
  labelText: 'Պրոդուկտի փուլը',
};

export default hy;
